import Button from "@/components/button/Button.tsx";
import {SlackPreviewCard} from "@/pages/integrations/edit/subForms/slack/SlackPreviewCard.tsx";
import {SlackAlertType, SlackSectionToggles} from "@/pages/integrations/edit/subForms/slackInfo.ts";

interface SlackPreviewSlotProps {
  alertType: SlackAlertType;
  toggles: SlackSectionToggles;
  onSendTest: (alertType: SlackAlertType) => void;
}

export const SlackPreviewSlot = ({alertType, toggles, onSendTest}: SlackPreviewSlotProps) => {
  const isDown = alertType === "down";
  return (
    <div className="d-flex flex-column align-items-start gap-2">
      <SlackPreviewCard alertType={alertType} toggles={toggles} />
      <Button
        variant="linkBlue"
        size="text"
        typography="linkTiny"
        onClick={() => onSendTest(alertType)}
        aria-label={`Send test ${isDown ? "DOWN" : "UP"} message to Slack`}
      >
        Send test {isDown ? "DOWN" : "UP"} →
      </Button>
    </div>
  );
};
